import { useState } from 'react';

// a forceUpdate hook.
// FIXME:: This will make the commentService to properly update the Document.
// Ideally we wouldn't need to force update this component as react should take care
// But our comment service is pure JS and we need a communication bus to properly talk.
// Which we don't have now. TODO: Refactor CommentService in reactish way.
export function useForceUpdate() {
  const [value, setValue] = useState(0);

  return () => {
    setValue(() => value + 1);
  };
}
